import { withTheme } from 'theme';
import material3 from 'theme/material3';

const container = withTheme((theme) => ({
  width: '90%',
  paddingY: theme.spacing(2),
  maxWidth: '800px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  '& .MuiAutocomplete-root': {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  '& .MuiOutlinedInput-root': {
    background: material3.color.surfaceContainerLow
  }
}));

const stateInputSx = withTheme((theme) => ({
  width: '33%',
  maxWidth: '200px',
  minWidth: '33%',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: 'none',
    minWidth: '100%',
  },
  [theme.breakpoints.up('sm')]: {
    minWidth: '110px',
    width: '20%',
    maxWidth: '140px'
  }
}));

const styles = {
  container,
  stateInputSx
};

export default styles;
